module.exports = __webpack_public_path__ + "static/homeBlueBg-4ef7caf5e2f66ee3fe4ad18cf39bf164.jpg";